import { Select, SelectProps } from "antd";

import { departments as departmentOptions } from "../../../constants";

interface Props extends SelectProps {
  fieldName?: string;
}

export const DepartmentSelect = ({
  fieldName = "eDepartment",
  ...restProps
}: Props) => {
  return <Select {...restProps} options={departmentOptions} />;
};
